// import store from "@/state/store";

export default [
    {
        path: '/',
        redirect: "/login",
    },
    {
        path: "/login",
        name: "login",
        component: () => import("../views/login/login1"),
    },
    {
        path: "/login1",
        name: "login1",
        component: () => import("../views/login/login"),
    },
    {
        path: "/register",
        name: "loregistergin1",
        component: () => import("../views/login/register"),
    },
    {
        path: "/forgetPassword",
        name: "forgetPassword",
        component: () => import("../views/login/forgetPassword"),
    },
    {
        path: "/updateEmail",
        name: "updateEmail",
        component: () => import("../views/login/updateEmail"),
    },
    {
        path: "/account_business_information",
        name: "account_business_information",
        component: () => import("../views/account_business_information/index.vue"),
    },
    /* 首页 */
    // dashboard-质量
    {
        path: "/dashboard-quality",
        name: "dashboardQuality",
        meta: {
            title: "dashboard",
            authRequired: true,
        },
        component: () => import("../views/dashboard/quality/index"),
    },
    {
        path: "/dashboard-quality-digital-passport",
        name: "dashboardQualityDigitalPassport",
        meta: {
            title: "dashboard",
            authRequired: true,
        },
        component: () => import("../views/dashboard/quality/digitalPassport"),
    },
    {
        path: "/dashboard-quality-index-list",
        name: "dashboardQualityIndexList",
        meta: {
            title: "dashboard",
            authRequired: true,
        },
        component: () => import("../views/dashboard/quality/indexList"),
    },
    {
        path: "/dashboard-quality-search-product",
        name: "dashboardQualitySearchProduct",
        meta: {
            title: "dashboard",
            authRequired: true,
        },
        component: () => import("../views/dashboard/quality/qualitySearch"),
    },
    {
        path: "/dashboard-quality-search-institution",
        name: "dashboardQualitySearchInstitution",
        meta: {
            title: "dashboard",
            authRequired: true,
        },
        component: () => import("../views/dashboard/quality/qualitySearch1"),
    },
    // dashboard-环境足迹
    {
        path: "/dashboard-environment",
        name: "dashboardEnvironment",
        meta: {
            title: "dashboard",
            authRequired: true,
        },
        component: () => import("../views/dashboard/environment/index"),
    },
    {
        path: "/dashboard-environment-digital-passport",
        name: "dashboardEnvironmentDigitalPassport",
        meta: {
            title: "dashboard",
            authRequired: true,
        },
        component: () => import("../views/dashboard/environment/digitalPassport"),
    },
    {
        path: "/dashboard-environment-index-list",
        name: "dashboardEnvironmentIndexList",
        meta: {
            title: "dashboard",
            authRequired: true,
        },
        component: () => import("../views/dashboard/environment/indexList"),
    },
    {
        path: "/dashboard-environment-search-product",
        name: "dashboardEnvironmentSearchProduct",
        meta: {
            title: "dashboard",
            authRequired: true,
        },
        component: () => import("../views/dashboard/environment/qualitySearch"),
    },
    {
        path: "/dashboard-environment-search-institution",
        name: "dashboardEnvironmentSearchInstitution",
        meta: {
            title: "dashboard",
            authRequired: true,
        },
        component: () => import("../views/dashboard/environment/qualitySearch1"),
    },
    // dashboard-ESG
    {
        path: "/dashboard-esg",
        name: "dashboardEsg",
        meta: {
            title: "dashboard",
            authRequired: true,
        },
        component: () => import("../views/dashboard/esg/index"),
    },
    {
        path: "/dashboard-esg-digital-passport",
        name: "dashboardEsgDigitalPassport",
        meta: {
            title: "dashboard",
            authRequired: true,
        },
        component: () => import("../views/dashboard/esg/digitalPassport"),
    },
    {
        path: "/dashboard-esg-index-list",
        name: "dashboardEsgIndexList",
        meta: {
            title: "dashboard",
            authRequired: true,
        },
        component: () => import("../views/dashboard/esg/indexList"),
    },
    {
        path: "/dashboard-esg-search-product",
        name: "dashboardEsgSearchProduct",
        meta: {
            title: "dashboard",
            authRequired: true,
        },
        component: () => import("../views/dashboard/esg/qualitySearch"),
    },
    {
        path: "/dashboard-esg-search-institution",
        name: "dashboardEsgSearchInstitution",
        meta: {
            title: "dashboard",
            authRequired: true,
        },
        component: () => import("../views/dashboard/esg/qualitySearch1"),
    },
    // dashboard-circularity 循环性
    {
        path: "/dashboard-circularity",
        name: "dashboardCircularity",
        meta: {
            title: "dashboard",
            authRequired: true,
        },
        component: () => import("../views/dashboard/circularity/index"),
    },
    {
        path: "/dashboard-circularity-digital-passport",
        name: "dashboardCircularityDigitalPassport",
        meta: {
            title: "dashboard",
            authRequired: true,
        },
        component: () => import("../views/dashboard/circularity/digitalPassport"),
    },
    {
        path: "/dashboard-circularity-index-list",
        name: "dashboardCircularityIndexList",
        meta: {
            title: "dashboard",
            authRequired: true,
        },
        component: () => import("../views/dashboard/circularity/indexList"),
    },
    {
        path: "/dashboard-circularity-search-product",
        name: "dashboardCircularitySearchProduct",
        meta: {
            title: "dashboard",
            authRequired: true,
        },
        component: () => import("../views/dashboard/circularity/qualitySearch"),
    },
    {
        path: "/dashboard-circularity-search-institution",
        name: "dashboardCircularitySearchInstitution",
        meta: {
            title: "dashboard",
            authRequired: true,
        },
        component: () => import("../views/dashboard/circularity/qualitySearch1"),
    },
    // dashboard-comfort  感官舒适性
    {
        path: "/dashboard-comfort",
        name: "dashboardComfort",
        meta: {
            title: "dashboard",
            authRequired: true,
        },
        component: () => import("../views/dashboard/comfort/index"),
    },
    {
        path: "/dashboard-comfort-digital-passport",
        name: "dashboardComfortDigitalPassport",
        meta: {
            title: "dashboard",
            authRequired: true,
        },
        component: () => import("../views/dashboard/comfort/digitalPassport"),
    },
    {
        path: "/dashboard-comfort-index-list",
        name: "dashboardComfortIndexList",
        meta: {
            title: "dashboard",
            authRequired: true,
        },
        component: () => import("../views/dashboard/comfort/indexList"),
    },
    {
        path: "/dashboard-comfort-search-product",
        name: "dashboardComfortSearchProduct",
        meta: {
            title: "dashboard",
            authRequired: true,
        },
        component: () => import("../views/dashboard/comfort/qualitySearch"),
    },
    {
        path: "/dashboard-comfort-search-institution",
        name: "dashboardComfortSearchInstitution",
        meta: {
            title: "dashboard",
            authRequired: true,
        },
        component: () => import("../views/dashboard/comfort/qualitySearch1"),
    },
    // dashboard-traceability 可追溯性
    {
        path: "/dashboard-traceability",
        name: "dashboardTraceability",
        meta: {
            title: "dashboard",
            authRequired: true,
        },
        component: () => import("../views/dashboard/traceability/index"),
    },
    {
        path: "/dashboard-traceability-digital-passport",
        name: "dashboardTraceabilityDigitalPassport",
        meta: {
            title: "dashboard",
            authRequired: true,
        },
        component: () => import("../views/dashboard/traceability/digitalPassport"),
    },
    {
        path: "/dashboard-traceability-index-list",
        name: "dashboardTraceabilityIndexList",
        meta: {
            title: "dashboard",
            authRequired: true,
        },
        component: () => import("../views/dashboard/traceability/indexList"),
    },
    {
        path: "/dashboard-traceability-search-product",
        name: "dashboardTraceabilitySearchProduct",
        meta: {
            title: "dashboard",
            authRequired: true,
        },
        component: () => import("../views/dashboard/traceability/qualitySearch"),
    },
    {
        path: "/dashboard-traceability-search-institution",
        name: "dashboardTraceabilitySearchInstitution",
        meta: {
            title: "dashboard",
            authRequired: true,
        },
        component: () => import("../views/dashboard/traceability/qualitySearch1"),
    },
    /* 主页 */
    {
        path: "/homePage",
        name: "homePage",
        meta: {
            title: "homePage",
            authRequired: true,
        },
        component: () => import("../views/homePage/index.vue"),
    },
    /* 用户信息 */
    {
        path: "/user_info",
        name: "user_info",
        // redirect: "/login",
        meta: {
            title: "user_info",
            authRequired: true,
        },
        component: () => import("../components/userInfo.vue"),
    },
    {
        path: "/hscode_management",
        name: "hscode_management",
        meta: {
            title: "hscode_management",
            authRequired: true,
            permission: 'hscode.list',
        },
        component: () => import("../views/hscode_management/Index.vue"),
    },
    {
        path: "/product_template",
        name: "product_template",
        meta: {
            title: "product_template",
            authRequired: true,
            permission: 'product-template.list',
        },
        component: () => import("../views/product_template/index.vue"),
    },
    {
        path: "/product_template_detail",
        name: "product_template_detail",
        meta: {
            title: "product_template_detail",
            authRequired: true,
            permission: 'product-template.show',
            father: 'product_template'
        },
        component: () => import("../views/product_template/Detail.vue"),
    },
    {
        path: "/products/:id",
        name: "products",
        meta: {
            title: "products",
            authRequired: true,
        },
        component: () => import("../views/products/index.vue"),
    },
    {
        path: "/productsList",
        name: "productsList",
        meta: {
            title: "productsList",
            authRequired: true,
        },
        component: () => import("../views/productsList/index.vue"),
    },
    {
        path: "/products_detail",
        name: "products_detail",
        meta: {
            title: "products_detail",
            authRequired: true,
            permission: ['my.product.add', 'my.product.modify'],
        },
        component: () => import("../views/products/detail.vue"),
    },
    {
        path: "/products_info",
        name: "products_info",
        meta: {
            title: "products_info",
            authRequired: true,
            permission: ['my.product.show'],
        },
        component: () => import("../views/products/info.vue"),
    },
    {
        path: "/hscode_management_detail",
        name: "hscode_management_detail",
        meta: {
            title: "hscode_management_detail",
            authRequired: true,
            permission: ['hscode.add', 'hscode.edit'],
            father: 'hscode_management'
        },
        component: () => import("../views/hscode_management/Detail.vue"),
    },
    {
        path: "/business_information_management",
        name: "business_information_management",
        meta: {
            title: "business_information_management",
            authRequired: true,
            permission: 'business-user.list',
        },
        component: () => import("../views/businessInformationManagement/index.vue"),
    },
    {
        path: "/business_information_management_examine",
        name: "business_information_management_examine",
        meta: {
            title: "business_information_management_examine",
            authRequired: true,
            permission: 'business-user.show',
            father: 'business_information_management'
        },
        component: () => import("../views/businessInformationManagement/examine.vue"),
    },
    {
        path: "/business_information_management_detail",
        name: "business_information_management_detail",
        meta: {
            title: "business_information_management_detail",
            authRequired: true,
            permission: 'business-user.show',
            father: 'business_information_management'
        },
        component: () => import("../views/businessInformationManagement/detail.vue"),
    },
    {
        path: "/business_products_management",
        name: "business_products_management",
        meta: {
            title: "business_products_management",
            authRequired: true,
            permission: 'business-product.list',
        },
        component: () => import("../views/businessProductsManagement/index.vue"),
    },
    {
        path: "/business_products_management_detail",
        name: "business_products_management_detail",
        meta: {
            title: "business_products_management_detail",
            authRequired: true,
            permission: 'business-product.show',
            father: 'business_products_management'
        },
        component: () => import("../views/businessProductsManagement/detail.vue"),
    },
    {
        path: "/supplyChain",
        name: "supplyChain",
        meta: {
            title: "supplyChain",
            authRequired: true,
            permission: 'my.supply-chain.list',
        },
        component: () => import("../views/supplyChain/index.vue"),
    },
    // {
    //     path: "/supplyChain_detail",
    //     name: "supplyChain_detail",
    //     meta: {
    //         title: "supplyChain_detail",
    //         authRequired: true,
    //         // permission: 'business-product.show',
    //         father: 'supplyChain'
    //     },
    //     component: () => import("../views/supplyChain/detail.vue"),
    // },
    {
        path: "/product_line",
        name: "product_line",
        meta: {
            title: "product_line",
            authRequired: true,
            permission: 'my.production-line.list',
        },
        component: () => import("../views/productLine/index.vue"),
    },
    {
        path: "/account",
        name: "account",
        meta: {
            title: "account",
            authRequired: true,
            permission: 'my.account.show',
        },
        component: () => import("../views/account/index.vue"),
    },
    {
        path: "/account_inreview",
        name: "account_inreview",
        meta: {
            title: "account",
            authRequired: true,
            permission: 'my.account.show',
            father: '/account',
        },
        component: () => import("../views/account/reviewInfo.vue"),
    },

    {
        path: "/code",
        name: "code",
        meta: {
            title: "code",
            authRequired: false,
        },
        component: () => import("../views/components/QrCode.vue"),
    },
    /**
     * 报告
     */
    {
        path: "/report/:type/:id",
        name: "report",
        meta: {
            title: "report",
            authRequired: true,
        },
        component: () => import("../views/report/index.vue"),
    },
    /**
     * 系统管理
     */
    {
        path: "/system_management",
        name: "system_management",
        meta: {
            title: "system_management",
            authRequired: true,
        },
        component: () => import("@/views/system_management/index"),
    },
    {
        path: "/role",
        name: "role_management",
        meta: {
            title: "role_management",
            authRequired: true,
        },
        component: () => import("@/views/system_management/role/index"),
    },
    {
        path: "/user",
        name: "user_management",
        meta: {
            title: "user_management",
            authRequired: true,
        },
        component: () => import("@/views/system_management/user/index"),
    },
    // 树状结构
    {
        path: "/treeUser",
        name: "treeUser_management",
        meta: {
            title: "treeUser_management",
            authRequired: true,
        },
        component: () => import("@/views/system_management/treeUser/index"),
    },
    {
        path: "/permission",
        name: "permission_management",
        meta: {
            title: "permission_management",
            authRequired: true,
        },
        component: () => import("@/views/system_management/permission/index"),
    },
    // 语言设置
    {
        path: "/lang",
        name: "lang",
        meta: {
            title: "lang",
            authRequired: true,
        },
        component: () => import("@/views/system_management/language/index.vue"),
    },
    {
        path: "/lang1",
        name: "lang1",
        meta: {
            title: "lang1",
            authRequired: true,
        },
        component: () => import("@/views/system_management/lang/index.vue"),
    },
    // qrcode
    {
        path: "/organization/:id",
        name: "organization",
        meta: {
            authRequired: false,
        },
        component: () => import("@/views/mobile/qrcode/org"),
    },
    {
        path: "/passwort/:id",
        name: "passwort",
        meta: {
            authRequired: false,
        },
        component: () => import("@/views/mobile/qrcode/passport"),
    },
    // b2c商城配置
    {
        path: "/b2c",
        name: "b2c",
        meta: {
            authRequired: false,
        },
        component: () => import("@/views/system_management/b2c/index.vue"),
    },
    //商城详情查看的雷达图
    {
        path: "/radar",
        name: "radar",
        meta: {
            authRequired: false,
        },
        component: () => import("@/views/system_management/b2c/radar.vue"),
    },
];
